<label class="ml-2 text-body-02 text-black">
  <input
    #input
    type="checkbox"
    [ngClass]="{
      'border-secondary': isInvalid() && isTouched(),
    }"
    class="appearance-none w-4 h-4 border border-gray-40 hover:border-primary hover:bg-neutral-blue-1 duration-100 rounded"
    [ngModel]="checked()"
    (ngModelChange)="onModelChange($event)"
  />
  <span><ng-content></ng-content></span>
</label>

@if (isTouched() && (errors$ | async); as errors) {
  <div class="errors text-body-02 ml-6 mt-1 text-secondary no-underline" data-test-id="form-field-error">
    {{ errors }}
  </div>
}
